import Vue from 'vue';
import { COLOR_PAGE_BG } from '@/theme';
import { setDocumentTitle, formatAmount } from '@/util';
export default Vue.extend({
    name: 'FullGiftMyPurchaseRecord',
    data() {
        return {
            COLOR_PAGE_BG,
            loading: false,
            finished: false,
            page: 1,
            limit: 20,
            list: [],
        };
    },
    computed: {
        activityId() {
            return this.$route.query.activity_id || '';
        },
    },
    async mounted() {
        setDocumentTitle('消费记录');
        await this.fetchList();
        window.addEventListener('scroll', this.onScroll, true);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll, true);
    },
    methods: {
        fmtAmount(amount) {
            return formatAmount(amount);
        },
        async fetchList() {
            if (this.loading || this.finished)
                return;
            this.loading = true;
            try {
                const { data } = await this.$axios.get('/api/activity/fullGift/fullGift/myOrders', {
                    params: {
                        activity_id: this.activityId,
                        page: this.page,
                        limit: this.limit,
                    },
                });
                const rows = (data && data.list) || [];
                this.list = this.list.concat(rows);
                const count = (data && data.count) || 0;
                if (this.list.length >= count || rows.length < this.limit) {
                    this.finished = true;
                }
                else {
                    this.page += 1;
                }
            }
            catch {
                // errors handled silently; page stays in loading=false state
            }
            finally {
                this.loading = false;
            }
        },
        onScroll(e) {
            const el = e.target;
            if (!el || !el.scrollHeight)
                return;
            if (el.scrollHeight - el.scrollTop - el.clientHeight < 100) {
                this.fetchList();
            }
        },
    },
});
